<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-04 15:11:58
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-12 16:27:57
 * @FilePath: /chaoyongtuan/src/views/settings/tagManage/tagManage.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="main-content-padding">
		<Panel :contentPaddingTop="0" v-if="tabList.length">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane :label="item.label" :name="item.name" v-for="(item, index) in tabList" :key="index"></el-tab-pane>
			</el-tabs>
			<goods-search v-if="+activeName === 0" ref="goodsSearch" @onSubmit="onSubmit" class="mt-16" />
			<content-search v-if="+activeName === 1" @onSubmit="onSubmit" ref="contentSearch" class="mt-16" />
		</Panel>
		<Panel v-if="tabList.length">
			<goods-tag v-if="+activeName === 0" ref="goodsTag"></goods-tag>
			<content-tag v-if="+activeName === 1" ref="contentTag" />
		</Panel>
		<Panel v-if="!tabList.length">
			<empty ref="empty">
				<img slot="image" src="@/assets/public/admin-img.png" alt="" />
				<div class="fz-14 yx-color-text-regular mt-10" slot="desc">
					<p>暂无权限查看</p>
					<p>可联系管理员开通查看标签管理</p>
				</div>
			</empty>
		</Panel>
	</div>
</template>
<script>
import contentSearch from './components/contentLibrayTag/search.vue';
import goodsSearch from './components/goodsTag/components/search.vue';
import contentTag from './components/contentLibrayTag/contentLibrayTag.vue';
import goodsTag from './components/goodsTag/goodsTag.vue';
import empty from '@/views/common/empty/index.vue';
export default {
	data() {
		return {
			activeName: '',
		};
	},
	components: {
		contentSearch,
		contentTag,
		goodsTag,
		goodsSearch,
		empty
	},
	watch: {
		tabList: {
			handler(to = []) {
				const [{ name, ref } = {}] = to;
				this.activeName = name;
				this.$nextTick(() => {
					this.$refs[ref]?.onSubmit();
				});
			},
			immediate: true,
			deep: true,
		},
	},
	computed: {
		tabList() {
			let obj1 = {
				label: '商品标签',
				name: '0',
				ref: 'goodsTag',
				isShow: this.$auth.hasPermi('tags:list'),
			};

			let obj2 = {
				label: '内容标签',
				name: '1',
				ref: 'contentTag',
				isShow: this.$auth.hasPermi('teamManageTag:contentTag'),
			};

			return [obj1, obj2].filter(item => item.isShow);
		},
	},
	methods: {
		onSubmit(val) {
			this.$nextTick(() => {
				const clearObj = {
					0: this.$refs.goodsTag?.onSubmit,
					1: this.$refs.contentTag?.onSubmit,
				};
				clearObj[this.activeName](val);
			});
		},
		handleClick() {
			this.$nextTick(() => {
				const clearObj = {
					0: this.$refs.goodsTag?.onSubmit,
					1: this.$refs.contentTag?.onSubmit,
				};
				clearObj[this.activeName]();
			});
		},
	},
};
</script>
